import { render, staticRenderFns } from "./order.vue?vue&type=template&id=c469c2b6&scoped=true&"
import script from "./order.js?vue&type=script&lang=js&"
export * from "./order.js?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=c469c2b6&prod&lang=css&"
import style1 from "./order.vue?vue&type=style&index=1&id=c469c2b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c469c2b6",
  null
  
)

export default component.exports